import { winteriseMyFarmDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getwinteriseMyFarmEn = () => {
  const data = winteriseMyFarmDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addwinteriseMyFarm = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-do-i-best-winterize-my-farm`,
    ) &&
    document.getElementById(`winteriseMyFarmJSONLD`) === null
  ) {
    const script = WinteriseMyFarmJSONLDEn()
    addJSONLDToHead(script, `winteriseMyFarmJSONLD`)
  } else {
    removeElement(`winteriseMyFarmJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const WinteriseMyFarmJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getwinteriseMyFarmEn(),
  }
  return FaqBagsterTemplate
}
